import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UserInformationForm from 'shared/account/components/UserInformationForm';
import { getRegisterFormFields } from 'shared/account/reducer';
import { registerUser } from '../actions';
var getDisplayPassword = function getDisplayPassword(match) {
  if (typeof match.params.data !== 'undefined') {
    return true;
  }
  try {
    return !JSON.parse(Buffer.from(decodeURIComponent(match.params.data), 'base64'));
  } catch (error) {
    return true;
  }
};
var RegisterForm = function RegisterForm(_ref) {
  var _URLSearchParams$get;
  var formData = _ref.formData,
    match = _ref.match,
    _ref$onSuccessfulRegi = _ref.onSuccessfulRegistration,
    onSuccessfulRegistration = _ref$onSuccessfulRegi === void 0 ? function () {} : _ref$onSuccessfulRegi,
    referringUrl = _ref.referringUrl;
  var dispatch = useDispatch();
  var fields = useSelector(getRegisterFormFields);
  var processing = useSelector(function (_ref2) {
    var authentication = _ref2.authentication;
    return authentication.status.processing;
  });
  var displayPassword = getDisplayPassword(match);
  var origin = (_URLSearchParams$get = new URLSearchParams(window.location.search).get('origin')) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : undefined;
  var handleRegisterUser = function handleRegisterUser(userUpdateRequest) {
    dispatch(registerUser(userUpdateRequest, referringUrl, origin)).then(function (_ref3) {
      var loggedIn = _ref3.loggedIn,
        redirectUri = _ref3.redirectUri;
      if (!loggedIn) {
        return;
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'signupComplete'
        });
      }
      onSuccessfulRegistration(referringUrl || redirectUri || '/');
    });
  };
  return /*#__PURE__*/React.createElement(UserInformationForm, {
    displayPassword: displayPassword,
    fields: fields,
    formData: formData,
    persistData: handleRegisterUser,
    processing: processing,
    testAttribute: "registration-form"
  });
};
export default RegisterForm;